import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { LocationProp } from '../../models/Location';
import { DropdownItem } from '../../components/DropdownItem/DropdownItem';
import { ABUtils } from '../../utils';

class TopDestinationItem extends PureComponent {
    onClickItem = (event) => {
        const {
            index,
            item,
            onClickItem,
            trackEvent,
            trackAutocompleteSourceSelection,
        } = this.props;
        const visibleItems = event?.currentTarget?.parentElement?.children;
        const visibleIndex = visibleItems
            ? Array.prototype.indexOf.call(visibleItems, event.currentTarget)
            : -1;
        const visualPosition = visibleIndex >= 0 ? visibleIndex + 1 : index + 1;
        trackEvent({ action: 'recommended_destinations', label: 'rec_sel_home_' + (index + 1) });
        trackAutocompleteSourceSelection({
            source: 'popular',
            position: visualPosition,
            queryLength: 0,
        });
        onClickItem(item);
    };

    render() {
        const { isCssVariationMobile } = ABUtils.getABs();
        const { item, isFixedWidth } = this.props;
        const countryStr = `, ${item.country}`;
        return (
            <DropdownItem
                onClick={this.onClickItem}
                iconClass='odf-icon-city odf-icon-bidi'
                isFixedWidth={isFixedWidth}
                iataCode={isCssVariationMobile ? item.iata : ''}
            >
                <span>{item.city}{countryStr}</span>
            </DropdownItem>
        );
    }
}

TopDestinationItem.propTypes = {
    index: PropTypes.number.isRequired,
    onClickItem: PropTypes.func.isRequired,
    item: LocationProp.isRequired,
    trackEvent: PropTypes.func.isRequired,
    trackAutocompleteSourceSelection: PropTypes.func,
    isFixedWidth: PropTypes.bool,
};

TopDestinationItem.defaultProps = {
    isFixedWidth: false,
    trackAutocompleteSourceSelection: () => {},
};

const connected = withPageContext(TopDestinationItem);
export { connected as TopDestinationItem };
